/**
 * Hidden fallback to the classic driver screens (old My day board, classic
 * service run detail as the run view, old stop screen). Set by an admin or the
 * server only; there is no user-facing switch.
 */
export const isLegacyMobileUi = user => user?.settings?.legacyMobileUi === true;
